import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import {useTranslation} from 'react-i18next';
import {loginUser} from '@store/reducers/auth';
import {Button, Input} from '@components';
import {faEnvelope, faUser} from '@fortawesome/free-solid-svg-icons';

import * as Yup from 'yup';

import * as UserService from '@app/services/UserService';
import {LOCAL_STORAGE_AUTH_TOKEN, ResponseCode} from '@app/constants/Common';

const ResetPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [resetDone, setResetDone] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const dispatch = useDispatch();

    const history = useHistory();
    const [t] = useTranslation();

    const resetPassword = async (username, email) => {
        setIsLoading(true);
        setErrorMessage("")
        UserService.requestResetPassword({username: username, email: email}).then((res) => {
            console.log(JSON.stringify(res))
            if (res.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Gửi yêu cầu cấp lại mật khẩu thành công.`);
                setResetDone(true)
            } else {
                setErrorMessage(res.message)
            }
        }).catch((error) => {
            setResetDone(false)
        }).finally(() => {
            setIsLoading(false);
        })
    };

    const formik = useFormik({
        initialValues: {
            username: '',
            email: ''
        },
        validationSchema: Yup.object({
            username: Yup.string()
                // .email('Invalid user name')
                .required('Required'),
            email: Yup.string()
                .email('Invalid email')
                .required('Required')
        }),
        onSubmit: (values) => {
            resetPassword(values.username, values.email);
        }
    });

    document.getElementById('root').classList = 'hold-transition login-page';

    return (
        <div className="login-box">
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <Link to="/" className="h1">
                        <b>GOPA </b>
                        <span>CRM</span>
                    </Link>
                </div>
                <div className="card-body">
                    {resetDone?
                        <><p className='login-box-msg'>Gửi yêu cầu cấp mật khẩu thành công.
                            Mật khẩu mới sẽ được chúng tôi gửi tới bạn trong thời gian sớm nhất</p>
                        </> :
                        <>
                            <p className='login-box-msg'>Yêu cầu cấp lại mật khẩu</p>
                            <p className={'text-danger'}>{errorMessage}</p>
                            <form onSubmit={formik.handleSubmit}>
                                <div className='mb-3'>
                                    <Input
                                        icon={faUser}
                                        placeholder='Tên đăng nhập'
                                        type='text'
                                        formik={formik}
                                        formikFieldProps={formik.getFieldProps('username')}
                                    />
                                </div>
                                <div className='mb-3'>
                                    <Input
                                        icon={faEnvelope}
                                        placeholder='email'
                                        type='email'
                                        formik={formik}
                                        formikFieldProps={formik.getFieldProps(
                                            'email'
                                        )}
                                    />
                                </div>

                                <div className='row'>
                                    <div className='col-12 mt-3 text-center'>
                                        <Button
                                            block
                                            type='submit'
                                            isLoading={isLoading}
                                            disabled={
                                                isLoading
                                            }
                                        >
                                            Gửi yêu cầu
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </>
                    }
                    <div className="col-12 text-center mt-3">
                        <Link to='/login'>
                            Về màn hình login
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
